import { combineReducers } from 'redux'
import {
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  LOADING,
  PUSH_ERRORS,
  CLEAR_MESSAGES
} from '../actions'

export const initErrors = {
  customerId: false,
  userId: false
}

const loading = (state = false, action) => {
  switch (action.type) {
    case LOADING:
      return action.loading
    default:
      return state
  }
}

const errors = (state = initErrors, action) => {
  switch (action.type) {
    case PUSH_ERRORS:
      return action.errors
    case CLEAR_MESSAGES:
      return initErrors
    default:
      return state
  }
}

const showSuccess = (state = false, action) => {
  switch (action.type) {
    case RESET_PASSWORD_SUCCESS:
      return true
    case CLEAR_MESSAGES:
      return false
    default:
      return state
  }
}

const showError = (state = false, action) => {
  switch (action.type) {
    case RESET_PASSWORD_ERROR:
      return true
    case CLEAR_MESSAGES:
      return false
    default:
      return state
  }
}

export default combineReducers({
  loading,
  errors,
  showSuccess,
  showError
})